import React from 'react'
import * as service from 'service'

import { makeStyles } from '@material-ui/core/styles'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Paper,
  Typography,
} from '@material-ui/core/'

const useStyles = makeStyles(theme => ({
  message: {
    marginBottom: theme.spacing(2),
  },
}))

const ClientDisable = ({ clientId, data }) => {
  const classes = useStyles()
  const [confirm, setConfirm] = React.useState(false)
  const [enabled, setEnabled] = React.useState(false)

  React.useEffect(() => {
    if (data) {
      setEnabled(data.active)
    }
  }, [data])

  const handleDisable = async () => {
    try {
      const customer = { active: false }
      await service.recurrence.customers.put({ clientId, customer })
      setConfirm(false)
      setEnabled(false)
    } catch (error) {
      console.log(error)
    }
  }

  const toggleDisable = async () => {
    if (enabled) {
      return setConfirm(true)
    }

    try {
      const customer = { active: true }
      await service.recurrence.customers.put({ clientId, customer })
      setEnabled(true)
    } catch (error) {
      console.log(error)
    }
  }

  const renderTitle = enabled ? 'Inativar' : 'Ativar'

  return (
    <>
      <Paper>
        <Box p={2}>
          <Typography variant="h4">{renderTitle} cliente</Typography>
        </Box>
        <Divider />
        <Box p={2}>
          <Typography gutterBottom className={classes.message}>
            {enabled
              ? 'Ao inativar um cliente ele deixará de receber as cobranças.'
              : 'Ao ativar um cliente ele voltará a receber cobranças'}
          </Typography>
          <Button color="primary" variant="outlined" onClick={toggleDisable}>
            {renderTitle}
          </Button>
        </Box>
      </Paper>

      <Dialog open={confirm} onClose={() => setConfirm(false)}>
        <DialogTitle id="form-dialog-title">Inativar cliente?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Para prosseguir com a inativação, por favor digite o e-mail do
            cliente
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={handleDisable}>
            Inativar
          </Button>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setConfirm(false)}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ClientDisable
